module.exports = __webpack_public_path__ + "assets/8bbc9ed69ec14f8000ed92ec6c300a89.png";